const countrySlice = (set) => ({
  country: null,

  loadCountry: (country) => set({ country }),
});

export default countrySlice;
